<h1 matDialogTitle>
  <ng-container *ngIf="!data.id">New researcher certificate</ng-container>
  <ng-container *ngIf="data.id">Edit researcher certificate</ng-container>
</h1>
<mat-dialog-content>

  <aw-researcher-certificate-form [certificate]="data" (saved)="dialogRef.close(true)"
    (canceled)="dialogRef.close(false)"></aw-researcher-certificate-form>

</mat-dialog-content>